import * as React from "react";
import type { ChronoEntry } from "@/types/chronology";

interface Props {
  chronoRecord: ChronoEntry;
}

const LABEL_COLOR_MAP = {
  user: "bg-badge-green",
  referential: "bg-badge-green",
  nlp: "bg-badge-green",
  block: "bg-badge-green",
  cluster: "bg-badge-gold",
  "missing day": "bg-badge-purple",
  "missing year": "bg-badge-pink",
  "added date": "bg-badge-green",
  "no action": "bg-badge-grey",
  informative: "bg-badge-blue",
  past: "bg-badge-grey",
} as const;

export const ChronologyListRecordLabels: React.FC<Props> = ({ chronoRecord }) => {
  const { labels } = chronoRecord;
  return (
    <div className="flex gap-1">
      {labels
        .filter(label => label !== "no action")
        .map(label => (
          <span
            className={`inline-flex items-center rounded-full border border-transparent ${LABEL_COLOR_MAP[label]} whitespace-nowrap px-2.5 py-0.5 text-xs font-semibold text-white transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2`}
            key={label}
            title={label}
          >
            {label}
          </span>
        ))}
    </div>
  );
};
